import type { Paginator } from "types";
import type {
    OnboardingApplicationStepAndFieldHistoryLogEntry,
    WithApplicationStatus,
    WithFieldsComments,
    WithFieldsStatuses,
    WithRequestedChangeFileds
} from "features/onboarding/types";

type Changes =
    & WithRequestedChangeFileds
    & WithFieldsStatuses
    & WithFieldsComments
    & WithApplicationStatus;

export type OnboardingApplicationStepAndFieldHistoryLogEntryWithPreviousChanges =
    & OnboardingApplicationStepAndFieldHistoryLogEntry<
        Changes
    >
    & {
        readonly previousChanges: Changes;
    };

export type OnboardingApplicationLogsPaginator<TData = OnboardingApplicationStepAndFieldHistoryLogEntry<Changes>> =
    & Omit<Paginator<unknown>, 'data'>
    & {
        readonly data: TData;
    };

export const enum OnboardingApplicationLogTab {
    Step = '1',
    Application = '2'
}

export const enum Resource {
    Applications= 'applications'
}
